<template>
    <div>
    <div style="width: 100%">
      <div class="top">
        <div class="fl logo"><img src="../assets/logo.png" alt=""></div>
        <ul  class="toptoo" v-if = "toptool[0]!=undefined">
          <li class="fl toptool" v-for="(item,index) in toptool" @click="tohelp(item.name)">
            {{item.title}}
            <ul v-if="index!=0&&index!=toptool.length-1&&index!=1" >
              <li v-for="(ite,ind) in toptoolall[index]" @click="torout(ite.torouter)">
                  <div class="pp">{{ite.hh}}</div>
                  <div class="hh">{{ite.pp}}</div>
              </li>
            </ul>
          </li>
        </ul>
        <ul class="fr lore">
          <li class="register" onclick="javascript:location.href='https://app.weilian.xin/sup/#/supply/login'">管理后台</li>

        </ul>
      </div>
    </div>
        <router-view/>
        <div class="fooder">
            <div>
                <ul>
                    <li @click="changezhengshu(0)">国际顶级域名</li>
                    <li @click="changezhengshu(1)">出版物经营许可证</li>
                    <li @click="changezhengshu(2)">广播电视节目制作经营许可证</li>
                    <li @click="changezhengshu(3)">开户许可证</li>
                    <li @click="changezhengshu(4)">食品经营许可证</li>
                    <li @click="changezhengshu(5)">计算机软件著作权证书</li>
                    <li @click="changezhengshu(6)">网络文化经营许可证</li>
                    <li @click="changezhengshu(7)">营业执照</li>
                    <li style="border-right: 0px ;    margin-right: 0;" @click="changezhengshu(8)">增值电信业务许可证</li>
                </ul>
            </div>

            <div class="last">微涟科技有限公司版权所有©辽ICP备18009739号-1
                </br><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21010202000567"><img src="/site_static/img/bei.png" alt="" style=" width: 20px;position: relative;top: 5px;left: -2px;">公安备案号21010202000567</a>
                <a href="http://sq.ccm.gov.cn/ccnt/sczr/service/business/emark/toDetail/9822266df53f48ae8ab4362b81d28be2"><img src="/site_static/img/liao.png" alt="" style=" width: 26px;position: relative;top: 7px;">辽网文〔2019〕0607-005号</a>
            </div>
        </div>
        <div class="zhengshu" :style="zhengshuop">
            <div style="    width: 500px;position: absolute; top: 0;left: 0; right: 0; bottom: 0; margin: auto;">
                    <img :src="zhengshuimg[zhengshuindex]" alt="" style="width: 100%;   position: absolute;top: 0;left: 0;bottom: 0;margin: auto;" >
                    <mu-icon color="grey50" class="menu" value="close" style="position:absolute; top: 0px;right: -40px ;bottom: 0;margin: auto;"   size="38"  @click="closezhengshu"></mu-icon>

            </div>
        </div>
    </div>
</template>

<script>
    import mid from '../components/mid'
export default {
  name: 'index',
  components:{
    mid
    },
  data () {
    return {
      toptool: [
        {
          title: '首页',
          name: 'one'
        }, {
          title: '解决方案',
          name: 'jiejue'
        }, {
          title: '产品中心',
          name: 'jiejue'
        }, {
          title: '帮助中心',
          name: 'help'
        }
      ],
      toptoolall:[
              [],
              [],
              [
                {hh:'店铺装修',pp:'完全可视化操作，使用更便捷',torouter:'zhuangxiu'},
                {hh:'拼团',pp:'快速扩张推广，促进交易达成',torouter:'pintuan'},
                {hh:'在线客服系统',pp:'加强沟通，提高商品转化率',torouter:'kefu'},
                {hh:'电子卡密',pp:'自动发卡，提供虚拟商品的发售服务',torouter:'kami'},
                {hh:'代理改价',pp:'招募代理快速开店',torouter:'mid'}

              ],[]
      ],
        zhengshuimg:[
            '/site_static/img/zhengshu/zhengshu1.png','/site_static/img/zhengshu/zhengshu2.jpg','/site_static/img/zhengshu/zhengshu3.jpg','/site_static/img/zhengshu/zhengshu4.jpg','/site_static/img/zhengshu/zhengshu5.png','/site_static/img/zhengshu/zhengshu6.jpg','/site_static/img/zhengshu/zhengshu7.jpg','/site_static/img/zhengshu/zhengshu8.jpg','/site_static/img/zhengshu/zhengshu9.png'],
        zhengshuindex:0,
        zhengshuop:'display:none'
    }
  },
    methods:{
      tohelp(name){
          if (name) {
            this.$router.push({name:name})
          }
      },
        changezhengshu(k){
            this.zhengshuindex=k
            this.zhengshuop='dispaly:block'
        },
        closezhengshu(){
            this.zhengshuop='display:none'
        },
        torout(o){
            this.$router.push({name:o})
            window.open(window.location.href)
            this.$router.push({name:'mid'})
            this.$router.push({name:'one'})
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a{
    text-decoration:none;
    color:#333;
}
h1, h2 {
font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.fooder{
    background: #1c1c25;
    width: 100%;
}
.fooder>div{
    padding: 74px 78px 30px 40px;
    color: #fff;
    font-size: 14px;
    overflow: hidden;
}
.fooder ul{
    width: 1535px;
    overflow: hidden;
    margin: 0 auto;
}
.fooder>div>ul>li{
    float: left;
    padding: 0 20px;
    border-right: 1px solid #fff;
    cursor: pointer;
}
.fooder>div>ul>li:hover,
.fooder>div>ul>li.active
{
    color:  #FB6638;
}
.last{
    color: #5f5f5f!important;
    text-align: center;
    line-height: 80px;
    border-top: 1px solid #252525;
    padding: 0!important;
}
.zhengshu{
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,.6);
    top: 0;
    left: 0;
    z-index: 999;
}
.top{
  width: 80%;
  height: 80px;
  margin: 0 auto;
}
  .fl{
    float: left;
  }
  .fr{
    float:right;
  }
  .toptool{
    line-height: 80px;
    font-size: 14px;
    padding: 0 7px;
    position: relative;
  }
  .toptool:hover,
  .toptool.active{
    color:#fb6638;
    cursor:pointer;
  }
.toptool:hover>ul{
  display: block;
}
  .logo{
    margin-top: 20px;
  }
  .toptoo{
    display: inline-block;
    margin: 0;
  }
  .toptool>ul{
    display: none;
    position: fixed;
    top: 80px;
    left: 30%;
    width: 600px;
    background: #fff;
    font-size: 12px;
    padding: 34px 20px 14px 20px;
    z-index: 99;
    border-radius: 4px;
    box-shadow: 0 0 24px rgba(0,0,0,0.1);
  }
.toptool>ul>li{
  width: 200px;
  box-sizing: border-box;
  padding: 0 0 20px 0;
  margin: 0;
  overflow: hidden;
  float: left;
}
.pp{
  font-size: 14px;
  color: #3b426b;
  padding-bottom: 20px;
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 180px;
  height: 53px;
  text-align: left;
}
.pp:after{
  content: '';
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 36px;
  height: 2px;
  background: #fb6638;
}
  .lore>li{
    width: 76px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border-radius: 4px;
    font-size: 14px;
    box-sizing: border-box;
    margin-top: 8px;
    cursor: pointer;
  }
  .hh{
    color: #7d88a2;
    font-size: 12px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 180px;
    height: 53px;
    text-align: left;
  }
  .login{
    background: #fb6638;
    color: #fff;
  }
  .register{
    color: #fb6638;
    border: 1px solid #fb6638;
  }
  .register:hover{
    background: #fb6638;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue